import axios from 'axios'

/**
 * 每日资源服务
 */
class DailyResourcesService {
  /**
   * 获取每日资源
   * @param {string} type - 资源类型：tv（电视剧）或 movie（电影），可选
   * @param {string} search - 搜索关键词，可选
   * @returns {Promise} 返回每日资源数据
   */
  async getDailyResources(type = '', search = '') {
    try {
      const params = new URLSearchParams()
      
      if (type) {
        params.append('type', type)
      }
      
      if (search && search.trim()) {
        params.append('search', search.trim())
      }
      
      const url = `/api/interface/daily-resources${params.toString() ? '?' + params.toString() : ''}`
      const response = await axios.get(url)
      
      if (response.data.code === 200) {
        return {
          success: true,
          data: response.data.data
        }
      } else {
        return {
          success: false,
          message: response.data.message || '获取失败'
        }
      }
    } catch (error) {
      console.error('获取每日资源失败:', error)
      return {
        success: false,
        message: error.response?.data?.message || '网络错误，请稍后重试'
      }
    }
  }
}

export default new DailyResourcesService()

